'use client'
import { createContext } from 'react'
import { SessionType } from '@/modules/auth/utility/model/sessionType'

export const SessionContext = createContext<SessionType | undefined>(undefined)

export function SessionProvider({
  session,
  children,
}: {
  session: SessionType
  children: React.ReactNode
}) {
  return (
    <SessionContext.Provider value={session}>
      {children}
    </SessionContext.Provider>
  )
}
